import { useHead } from '@unhead/vue'

import { ContentfulPageMeta } from '@/types'

export function usePageMeta() {
  function setPageMeta(pageMetaEntry: ContentfulPageMeta) {
    const pageMeta = pageMetaEntry?.fields || {}
    useHead({
      title: pageMeta.title || undefined,
      meta: pageMeta.metaDescription
        ? [{ name: 'description', content: pageMeta.metaDescription }]
        : undefined,
    })
  }

  return {
    setPageMeta,
  }
}
